import React from "react"
import badge from "badges/epic.svg"
import { BadgeImage } from "backpack/badges/styled"

const Epic = props => <BadgeImage src={badge} {...props} />

export default Epic
